<template>
  <d-card class="card-small mb-3">
    <!-- Add New Input modal trigger -->
    <d-card-header class="border-bottom">
      <p class="d-inline mb-0 font-weight-bold d-block">{{ $t('editor.trackabletitle') }}</p>
      <button
        class="btn float-right btn-primary select-template mt-3"
        @click="handleClick"
      >{{ $t('editor.trackablebutton') }}</button>
    </d-card-header>
    <!-- Start Inputs -->
    <d-card-body class="p-2 pt-3">
      <template v-if="getLinks && getLinks.length">
        <div
          v-for="link in getLinks"
          :key="link.name"
          class="input-draggable"
          @click="addLink(link)"
        >{{ link.name }}</div>
      </template>
      <div v-else>
        <div class="input-draggable">{{ $t('editor.savedlinks') }}</div>
      </div>
    </d-card-body>
    <d-card-body class="p-2 pt-2">
      <div
        v-for="my_input in my_inputs"
        :key="my_input.my_input"
        class="input-draggable"
      >{{ my_input }}</div>
    </d-card-body>
    <!-- Modal (Add New Dynamic Link) -->
    <d-modal v-if="showModal" size="md" @close="handleClose">
      <d-modal-header>
        <d-modal-title>{{ $t('editor.trackablemodal') }}</d-modal-title>
      </d-modal-header>
      <d-modal-body class="pt-2">
        <div class="row mt-4">
          <div class="form-group col-md-12">
            <p>{{ $t('editor.trackabledescription') }}</p>
          </div>
        </div>
        <div class="row mt-2">
          <div class="form-group col-md-12">
            <label for="feInputAddress">{{ $t('editor.linkname') }}</label>
            <input
              id="feInputLink"
              type="text"
              :placeholder="$t('editor.linknameplaceholder')"
              class="text-capitalize form-control"
              v-model="linkName"
            />
          </div>
          <br />
        </div>
        <div class="row mt-1 mb-2">
          <div class="form-group col-md-12">
            <label for="feInputAddress">{{ $t('editor.linkurl') }}:</label>
            <input
              id="feInputLink"
              type="url"
              placeholder="https://"
              class="form-control"
              v-model="linkUrl"
            />
          </div>
          <br />
        </div>
      </d-modal-body>
      <div class="modal-footer">
        <d-button size="sm" class="ml-2 btn-accent" @click="addLinkOnce()">Add Once</d-button>
        <d-button
          size="sm"
          class="ml-2 btn-success"
          @click="saveAndAdd()"
        >{{ $t('editor.addandsave') }}</d-button>
      </div>
    </d-modal>
    <!-- / Modal Add New Input -->
  </d-card>
</template>

<script>
import { LINK_CREATE, LINK_GET_LIST } from "@/store/types";
import { mapGetters } from "vuex";

export default {
  name: "modal-add-link",
  computed: {
    ...mapGetters(["getLinks"])
  },
  data() {
    return {
      showModal: false,
      linkName: "",
      linkUrl: ""
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch(LINK_GET_LIST);
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    handleClick() {
      this.showModal = true;
    },
    handleClose() {
      this.showModal = false;
    },
    addLink(link) {
      this.$eventHub.$emit("add-link", link.url);
    },
    addLinkOnce() {
      this.$eventHub.$emit("add-link", this.linkUrl);
      this.handleClose();
    },
    async saveAndAdd() {
      const { linkUrl, linkName } = this;
      try {
        await this.$store.dispatch(LINK_CREATE, {
          name: linkName,
          url: linkUrl
        });
        this.$eventHub.$emit("add-link", linkUrl);
        this.handleClose();
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
